import { Middleware } from "@reduxjs/toolkit";
import { loginSuccess, logout, userSuccess } from "src/store/auth/authSlice";
import { queryClient } from "src/queryClient";
import { advanceAuthSession } from "src/store/auth/session";

export const authMiddleware: Middleware = (store) => (next) => (action) => {
  if (loginSuccess.match(action) || logout.match(action)) advanceAuthSession();
  const result = next(action);

  if (loginSuccess.match(action) || userSuccess.match(action)) {
    const authState = store.getState().auth;
    localStorage.setItem('authState', JSON.stringify(authState));
  }

  if (loginSuccess.match(action) || logout.match(action)) {
    queryClient.clear();
  }

  if (logout.match(action)) {
    localStorage.removeItem('authState');
  }

  return result;
};
